import type { GridFilterCellProps } from "@tql/ui-components-react/kendo/grid";
import { format } from "date-fns";

import { DebouncedTextFilterCell } from "~/shared/components/trax-grid/debounced-text-filter-cell/debounced-text-filter-cell.tsx";

import { getTimeFromTimeString } from "../../../../utils/time-from-date.ts";

/**
 * Format the stored `HH:mm` value to the 12-hour `h:mm a` representation
 * shown in the TimePicker, then substring-match against the filter text.
 * Comparison is lowercased so users can type "5pm", "5 pm", or "5:".
 */
const dispatchTimeContainsOperator = (
	fieldValue: string | null | undefined,
	filterValue: string,
): boolean => {
	if (!filterValue) return true;
	const date = getTimeFromTimeString(fieldValue ?? undefined);
	if (!date) return false;
	return format(date, "h:mm a")
		.toLowerCase()
		.includes(filterValue.toLowerCase());
};

/**
 * Filter cell for the dispatch-time column. Stored values are `HH:mm`
 * 24-hour strings, but the TimePicker displays them as 12-hour (`h:mm a`).
 * The default `contains` operator would match the raw 24-hour string, so
 * typing "5" returns rows with "15:02" (3:02 PM). Use a custom operator so
 * the filter matches what the user actually sees.
 */
export const DispatchTimeFilterCell = (props: GridFilterCellProps) => (
	<DebouncedTextFilterCell
		{...props}
		className={"filter-cell-padded"}
		operator={dispatchTimeContainsOperator}
	/>
);
